/*
 * Copyright (c) 2022. Nedaware SL
 */

import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarRef, TextOnlySnackBar} from "@angular/material/snack-bar";
import {HttpErrorResponse} from "@angular/common/http";
import {ErrorToStringService} from "../../api/error-to-string.service";

@Injectable({
    providedIn: 'root'
})
export class ErrorDisplayService {
    constructor(private _matSnack: MatSnackBar, private _errorTranslator: ErrorToStringService) {
    }

    /**
     * Devuelve el aviso abierto, para que quien lo abrió pueda cerrar ESE aviso (y no otro que haya salido después),
     * como hace EditionDialogComponent al guardar bien tras un error.
     */
    public displayError(error: any, duration: number = null): MatSnackBarRef<TextOnlySnackBar> {
        const string = this._errorTranslator.errorToString(error);
        return this.displayRaw(string, duration);
    }

    public displayRaw(error: string, duration: number = 5000, clases?: string[]): MatSnackBarRef<TextOnlySnackBar> {
        return this._matSnack.open(error, 'Ok', {duration: duration, panelClass: clases});
    }

    /**
     * Aviso de una petición de fichero (PDF, XML) que no ha llegado. Esas peticiones van como
     * arraybuffer, así que el cuerpo del error también llega en bytes: se decodifica para no perder el
     * hydra:description de la API.
     */
    public displayErrorAlDescargar(error: any, accion = 'descargar el documento') {
        const texto = this._errorTranslator.errorToString(ErrorDisplayService._conCuerpoLegible(error));
        this.displayRaw(`No se ha podido ${accion}. ${texto}`, null);
    }

    private static _conCuerpoLegible(error: any): any {
        if (!(error instanceof HttpErrorResponse) || !(error.error instanceof ArrayBuffer)) {
            return error;
        }
        let cuerpo = {};
        try {
            cuerpo = JSON.parse(new TextDecoder().decode(error.error)) ?? {};
        } catch (e) {
            // No es JSON (una página de error del servidor, un cuerpo vacío): se queda el aviso genérico.
        }
        return new HttpErrorResponse({
            error: cuerpo, headers: error.headers, status: error.status, statusText: error.statusText, url: error.url ?? undefined,
        });
    }
}
